<template>
    <!-- <div>
      <div class="btn-return"><返回</div> -->
    <div class="warpper">
        <div class="goods-info">
            <div class="tabs">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <div class="search">搜索</div>
                    <div style="display: inline-block;">
                        <img src="../../assets/shop/search-icon.png" alt="" class="icon-search"/>
                        <input type="text" class="input-search" v-model="searchText" placeholder="请输入内容"/>
                        <button class="btn-search" @click="searchGoods">搜索</button>
                    </div>

                    <div style="float: right;">
                        <div v-show="!isBtnCheck">
                            <button class="btn-check-all" @click="checkAllOtps">
                                <img src="../../assets/shop/no-check.png" alt="" class="btn-check-img"
                                     v-show="isChecked">
                                <img src="../../assets/shop/checked.png" alt="" class="btn-check-img"
                                     v-show="!isChecked">
                                <div class="btn-check-span">全选</div>
                            </button>
                            <button class="btn-onsale" @click="openOnsaleGoods">
                                确定上架
                            </button>
                        </div>
                        <button class="btn-onsale" @click="showChecked" v-show="isBtnCheck">
                            <img src="../../assets/shop/onsale.png" alt="" class="btn-check-img">
                            <div class="btn-check-span white">批量上架</div>
                        </button>
                    </div>

                    <el-tab-pane label="未上架" name="0" class="off-sale">
                        <template>
                            <el-table :data="onSaleList" :stripe="true" class="tab">
                                <el-table-column width="55" align="center"></el-table-column>
                                <el-table-column label="主图" align="center" width="134">
                                    <template slot-scope="scope">
                                        <img v-if="scope.row.briefImag.length" :src="scope.row.briefImag[0]" height="100px" width="100px">
                                    </template>
                                </el-table-column>

                                <el-table-column prop="name" label="名称" width="200" align="center"></el-table-column>

                                <el-table-column prop="money" label="销售价（元）" align="center">
                                    <template slot-scope="scope">
                                        {{rebuildPrice(scope.row.price)}}
                                    </template>
                                </el-table-column>

                                <el-table-column prop="y_money" label="园区币价" align="center">
                                    <template slot-scope="scope">
                                        {{rebuildPrice(scope.row.rpPrice)}}
                                    </template>
                                </el-table-column>

                                <el-table-column prop="saleCount" label="总销量" align="center"></el-table-column>

                                <el-table-column prop="time" label="上架时间" align="center">
                                    <template slot-scope="scope">
                                        {{rebuildTime(scope.row.saleTime)}}
                                    </template>
                                </el-table-column>

                                <el-table-column prop="address" label="操作" align="center">
                                    <template slot-scope="scope">
                                        <div class="opts-font pointer" @click="editGoodShelf(scope.row.id, 1)">上架</div>
                                        <div class="opts-font color-blue pointer" @click="editGoodInfo(scope.row.id)">编辑
                                        </div>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </template>
                        <el-pagination background layout="prev, pager, next" :current-page.sync="page"
                                       @current-change="changePage" :total="total" class="paging">
                        </el-pagination>
                    </el-tab-pane>

                    <el-tab-pane label="已上架" name="1" class="on-sale">
                        <template>
                            <el-table :data="notOnSaleList" :stripe="true" class="tab">
                                <el-table-column width="55" align="center"></el-table-column>
                                <el-table-column label="主图" align="center" width="134">
                                    <template slot-scope="scope">
                                        <img v-if="scope.row.briefImag.length" :src="scope.row.briefImag[0]" height="100px" width="100px">
                                    </template>
                                </el-table-column>

                                <el-table-column prop="name" label="名称" width="200" align="center"></el-table-column>

                                <el-table-column prop="money" label="销售价（元）" align="center">
                                    <template slot-scope="scope">
                                        {{rebuildPrice(scope.row.price)}}
                                    </template>
                                </el-table-column>

                                <el-table-column prop="y_money" label="园区币价" align="center">
                                    <template slot-scope="scope">
                                        {{rebuildPrice(scope.row.rpPrice)}}
                                    </template>
                                </el-table-column>

                                <el-table-column prop="saleCount" label="总销量" align="center"></el-table-column>

                                <el-table-column prop="time" label="上架时间" align="center">
                                    <template slot-scope="scope">
                                        {{rebuildTime(scope.row.saleTime)}}
                                    </template>
                                </el-table-column>

                                <el-table-column prop="address" label="操作" align="center">
                                    <template slot-scope="scope">
                                        <div class="opts-font pointer" @click="editGoodShelf(scope.row.id, 0)">下架</div>
                                        <div class="opts-font color-blue pointer" @click="editGoodInfo(scope.row.id)">编辑
                                        </div>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </template>
                        <el-pagination background layout="prev, pager, next" :total="total" :current-page.sync="page"
                                       class="paging"
                                       @current-change="changePage">
                        </el-pagination>
                    </el-tab-pane>

                </el-tabs>

            </div>
        </div>
    </div>
    <!-- </div> -->
</template>

<script>
  import {getGoodList, editGoodShelf} from '@/api/shop'

  export default {
    name: "goodsManage",
    data() {
      return {
        isTabShow: 'true',
        onSaleList: [],
        notOnSaleList: [],
        activeName: '0',
        isBtnCheck: 'true',
        isChecked: 'true',
        page: 1,
        total: 10,
        searchText: '',
        search: ''
      }
    },
    mounted() {
      this.getGoodList()
    },
    methods: {
      rebuildPrice(price) {
        return (price / 100).toFixed(2)
      },
      // 实现右上角全选按钮
      checkAllOtps() {
        // 图片切换
        this.isChecked = !this.isChecked;
        // 商品全选
        this.$refs.goodsTable.toggleAllSelection();
      },
      // 显示全选按钮 隐藏下架管理
      showChecked() {
        this.isTabShow = !this.isTabShow;
        this.isBtnCheck = !this.isBtnCheck;
      },

      getGoodList() {
        // status: 0上架  ,1下架
        let type = this.activeName;
        getGoodList({
          page: this.page,
          pageCount: 10,
          state: type,
          search: this.search
        }).then((res) => {
          let {total, goodsList} = res.data;
          this.total = total;
          if (Number(type) === 0) {
            this.onSaleList = goodsList;
          } else {
            this.notOnSaleList = goodsList;
          }
        })
      },

      openOnsaleGoods() {
        this.$confirm('是否上架该商品？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.onsaleGoods()
          this.$message({
            type: 'success',
            message: '上架成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消上架'
          });
        });
      },

      searchGoods() {
        this.search = this.searchText;
        this.page = 1;
        this.getGoodList();
      },

      rebuildTime: function (time, type) {
        if (!time) return '-'
        const date = new Date(time)
        const Y = date.getFullYear()
        const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)
        const D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate())
        const h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours())
        const m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes())
        if (type === 1) {
          return String(Y).concat('-', M, '-', D)
        }
        return String(Y).concat('年', M, '月', D, '日 ', h, ':', m)
      },
      changePage(page){
        this.page = page;
        this.getGoodList()
      },
      // 商品上传
      onsaleGoods() {
        console.log("上架商品");
      },

      handleClick() {
        this.page = 1;
        this.getGoodList()
      },

      editGoodShelf(id, state) {
        console.log(id)
        editGoodShelf({
          state: state,
          id: id
        }).then(() => {
          this.getGoodList()
        })
      },
      editGoodInfo(id) {
        this.$router.push({
          path: '/addGood',
          query: {
            id: id
          }
        })
      }
    },
  }
</script>

<style scoped>
    .warpper {
        background-color: #fff;
    }

    .opts-font {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 24px;
        display: inline-block;
        margin-right: 10px;
        margin-left: 10px;
    }

    .pointer {
        cursor: pointer;
    }


    .off-sale,
    .on-sale {
        text-align: center;
        margin: 24px 41px;
    }

    .tab {
        border: 1px #E4E7EC solid;
    }

    .color-blue {
        color: #5189F7;
    }

    .search {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 1;
        margin: 39px 20px 0 40px;
        display: inline-block;
    }

    .input-search {
        width: 246px;
        height: 32px;
        background: #F9F9F9;
        border-radius: 6px;
        display: inline-block;
        text-indent: 40px;
        /*缩进*/

    }

    .icon-search {
        width: 14px;
        height: 14px;
        position: relative;
        left: 34px;
        top: 3px;
    }

    .btn-search {
        width: 96px;
        height: 34px;
        background: #5189F7;
        border-radius: 6px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 1;
        margin-left: 20px;
    }

    .btn-check-all {
        width: 116px;
        height: 34px;
        background: #F9F9F9;
        border: 1px solid #E2E2E2;
        border-radius: 6px;
        position: relative;
        top: 3px;
    }

    .btn-check-img {
        width: 18px;
        height: 18px;
        position: relative;

        top: 2px;
        margin-left: 3px;
    }

    .btn-check-span {
        line-height: 1px;
        position: relative;
        bottom: 2px;
        display: inline-block;
        margin-left: 7px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #666666;
        line-height: 1;

    }

    .white {
        color: white;
    }

    .btn-onsale {
        width: 116px;
        height: 34px;
        background: #5189F7;
        border-radius: 6px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 1;
        margin: 29px 42px 0 10px;
    }

    .tab-onsale {
        margin: 34px 40px;
    }

    .btn-return {
        margin-bottom: 30px;
    }
</style>
<style>
    .el-tabs__nav-wrap {
        position: relative;
        top: 24px;
        left: 41px;
    }

    .el-table td,
    .el-table th {
        padding: 10px 0;
    }

    .el-table td.is-right,
    .el-table th.is-right {
        padding-right: 100px;
    }
</style>
